import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { TCompareType } from '../../types/compareType';

export enum ECompareTypeActionTypes {
  SetCompareType = 'compareType/set',
}

type TSetCompareType = ITypedReduxAction<ECompareTypeActionTypes.SetCompareType, TCompareType>;

export const setCompareType = actionGenerator<ECompareTypeActionTypes.SetCompareType, TCompareType>(
  ECompareTypeActionTypes.SetCompareType,
);

export type TSetCompareTypeActions = TSetCompareType;
